const mapResponsibleGamblingPage = (data) => {
  const { text, title } = data;
  return {
    text,
    title
  };
};

export default mapResponsibleGamblingPage;
